export const hasCommerceIntent = () => {
  // first check if we're in the standalone login app with a grant flow redirect
  const redirect = new URLSearchParams(window.location.search).get('redirect')
  if (redirect && redirect.startsWith('/grant-flow')) {
    return true
  }

  // then check if we're in the grant flow app using inline login
  const currentUrl = new URL(window.location.href)
  if (currentUrl.pathname.startsWith('/grant-flow')) {
    return true
  }

  return false
}

export const hasOONIntent = () => {
  return window.context === 'OON_P2P'
}

export const hasLocalIntent = () => {
  if (window.context !== 'CASH_LOCAL') {
    return false
  }

  const redirectSearchParamKey = Array.from(new URLSearchParams(window.location.search).keys()).find(
    key => key === 'redirect_to'
  )

  if (redirectSearchParamKey) {
    return false
  }

  return true
}

export const optionalScopeHeaders = () => {
  if (hasOONIntent()) {
    return { 'x-web-scope': 'oon' }
  } else if (hasCommerceIntent()) {
    return { 'x-web-scope': 'ap_checkout' }
  } else if (hasLocalIntent()) {
    return { 'x-web-scope': 'local' }
  }

  return undefined
}
